export default [
// Admin portal
  {
    path: '/admin-portal/institutions',
    name: 'institutions',
    component: () => import('@/views/pages/admin-portal-management/Institution.vue'),
    meta: {
      pageTitle: 'Institutions',
      breadcrumb: [
        {
          text: 'Admin Portal',
        },
        {
          text: 'Institutions',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin-portal/billing',
    name: 'billing',
    component: () => import('@/views/pages/admin-portal-management/Billings.vue'),
    meta: {
      pageTitle: 'Billing',
      breadcrumb: [
        {
          text: 'Admin Portal',
        },
        {
          text: 'Billing',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin-portal/user-management',
    name: 'user-management',
    component: () => import('@/views/pages/admin-portal-management/UserManagement.vue'),
    meta: {
      pageTitle: 'User Management',
      hasPermission: 'VIEW_USER',
      breadcrumb: [
        {
          text: 'Admin Portal',
        },
        {
          text: 'User Management',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin-portal/user-roles',
    name: 'user-roles',
    component: () => import('@/views/pages/admin-portal-management/UserRoles.vue'),
    meta: {
      pageTitle: 'User Roles',
      hasPermission: 'VIEW_USER_ROLE',
      breadcrumb: [
        {
          text: 'Admin Portal',
        },
        {
          text: 'User Roles',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin-portal/manage-permissions',
    name: 'manage-permissions',
    component: () => import('@/views/pages/admin-portal-management/ManagePermissions.vue'),
    meta: {
      pageTitle: 'Manage Permissions',
      breadcrumb: [
        {
          text: 'Admin Portal',
        },
        {
          text: 'Manage Permissions',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin-portal/system-access',
    name: 'system-access',
    component: () => import('@/views/pages/admin-portal-management/SystemAccess.vue'),
    meta: {
      pageTitle: 'System Access',
      hasPermission: 'VIEW_SYSTEM_ACCESS',
      breadcrumb: [
        {
          text: 'Admin Portal',
        },
        {
          text: 'System Access',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin-portal/custom-fields',
    name: 'custom-fields',
    component: () => import('@/views/pages/admin-portal-management/CustomFields.vue'),
    meta: {
      pageTitle: 'Custom Fields',
      hasPermission: 'VIEW_CUSTOM_FIELD',
      breadcrumb: [
        {
          text: 'Admin Portal',
        },
        {
          text: 'Custom Fields',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin-portal/database-size-tracker',
    name: 'database-size-tracker',
    component: () => import('@/views/pages/admin-portal-management/DatabaseSizeTracker.vue'),
    meta: {
      pageTitle: 'Database Size Tracker',
      hasPermission: 'DATA_HANDLING_REPORT',
      breadcrumb: [
        {
          text: 'Admin Portal',
        },
        {
          text: 'Database Size Tracker',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin-portal/subscription/view-configuration',
    name: 'view-configuration',
    component: () => import('@/views/pages/admin-portal-management/Subscription/Configuration.vue'),
    meta: {
      pageTitle: 'View Configuration',
      hasPermission: 'VIEW_SUBSCRIPTION_CONFIG',
      breadcrumb: [
        {
          text: 'Admin Portal',
        },
        {
          text: 'View Configuration',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin-portal/subscription/view-invoice',
    name: 'view-invoice',
    component: () => import('@/views/pages/admin-portal-management/Subscription/Invoice.vue'),
    meta: {
      pageTitle: 'View Invoice',
      hasPermission: 'VIEW_SUBSCRIPTION_INVOICE',
      breadcrumb: [
        {
          text: 'Admin Portal',
        },
        {
          text: 'View Invoice',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin-portal/subscription/view-payment-history',
    name: 'view-payment-history',
    component: () => import('@/views/pages/admin-portal-management/Subscription/PaymentHistory.vue'),
    meta: {
      pageTitle: 'View Payment History',
      hasPermission: 'VIEW_SUBSCRIPTION_HISTORY',
      breadcrumb: [
        {
          text: 'Admin Portal',
        },
        {
          text: 'View Payment History',
          active: true,
        },
      ],
    },
  },
]
